import { render } from "./TableShip_responsibles.vue?vue&type=template&id=4bc1f130&scoped=true"
import script from "./TableShip_responsibles.vue?vue&type=script&lang=js"
export * from "./TableShip_responsibles.vue?vue&type=script&lang=js"

import "./TableShip_responsibles.vue?vue&type=style&index=0&id=4bc1f130&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc1f130"]])

export default __exports__